module.exports = __webpack_public_path__ + "img/level-down-alt-solid.aad3fb77.svg";